import { usePage } from 'client/store'
import {
  isWebsitePageType,
  pageSelectors,
} from 'client/store/page/pageSelectors'
import React from 'react'
import { useTypography } from 'src/editor/shared/hooks/use-typography'
import BaseFont, { FontProps, getInheritedFontTypeLabel } from './BaseFont'

function TextFont({
  fontFamily,
  fontStyle,
  fontWeight,
  labelText,
  update,
}: FontProps) {
  const { globalFontFamily } = useTypography()
  const pageType = usePage(pageSelectors.getPageType)
  const isWebsitePage = usePage(isWebsitePageType)
  const parentGlobalSettings = usePage(pageSelectors.getParentGlobalSettings)
  let inheritedFontTypeLabel = getInheritedFontTypeLabel(pageType)
  if (
    parentGlobalSettings &&
    Object.keys(parentGlobalSettings).length === 0 &&
    !isWebsitePage
  ) {
    inheritedFontTypeLabel = 'settings_styles.font_family.inherited'
  }
  return (
    <BaseFont
      labelText={labelText}
      fontFamily={fontFamily}
      fontStyle={fontStyle}
      fontWeight={fontWeight}
      update={update}
      globalFontFamily={globalFontFamily}
      inheritedFontTypeLabel={inheritedFontTypeLabel}
    />
  )
}
export default TextFont
